import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function getControlloTelefonoCellulare(telefono,tipologiaNumero,apiPath) {
    return (dispatch) => {
        API.getAxios(apiPath).get(`/anagrafica/telefono/${telefono}/controllo?tipoNumero=${tipologiaNumero}`)
        .then(response => { 
            dispatch({ type: actionTypes.CONTROLLO_TELEFONO_CELLULARE, payload: response.data})
        })
        .catch(errore => {
            dispatch({ type: actionTypes.CONTROLLO_TELEFONO_CELLULARE, payload: errore.response.data});
        })
    };
}

export default getControlloTelefonoCellulare;